import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import { withCookieConsent } from 'LiveBoard/hocs'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { ACCESSIBILITY_CLASSES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const SearchForm = (props) => {
  const submitHandler = ({query}) => {
    props.onSubmit(query)
    props.reset()
  }

  const formSubmit = () => props.handleSubmit(submitHandler)

  const handleChange = () => props.onCookieConsent()

  return (
    <form
      className="search-form"
      onSubmit={formSubmit()} >
      <Field
        className={`search-input`}
        name="query"
        component="input"
        type="text"
        placeholder={`${props.getTranslation(TRANSLATION_VALUE_KEYS.search)}...`}
        onChange={handleChange}/>
      <span
        className="icon-search"
        onClick={formSubmit()} />
    </form>
  )
}

SearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  onCookieConsent: PropTypes.func.isRequired
}

export default withCookieConsent(reduxForm({})(withTranslation(TRANSLATION_KEYS.searchForm)(SearchForm)))
